import React from 'react';

interface KeyAreaTagProps {
  icon: string;
  name: string;
}

export function KeyAreaTag({ icon, name }: KeyAreaTagProps) {
  return (
    <span style={styles.chip}>
      <span style={styles.icon}>{icon}</span>
      <span style={styles.name}>{name}</span>
    </span>
  );
}

const styles: Record<string, React.CSSProperties> = {
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '2px 8px',
    borderRadius: '9999px',
    backgroundColor: '#e8f5e9',
    fontSize: '12px',
    lineHeight: '1.4',
    whiteSpace: 'nowrap',
  },
  icon: {
    flexShrink: 0,
  },
  name: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '120px',
  },
};
